export type PasswordStrength = {
  score: number;
  label: string;
  variant: string;
};

export const calculatePasswordStrength = (password: string): PasswordStrength => {
  if (!password) {
    return { score: 0, label: 'No password', variant: 'danger' };
  }

  let score = 0;
  const checks = [
    { regex: /.{8,}/, points: 1 }, // Length >= 8
    { regex: /[A-Z]/, points: 1 }, // Has uppercase
    { regex: /[a-z]/, points: 1 }, // Has lowercase
    { regex: /[0-9]/, points: 1 }, // Has number
    { regex: /[^A-Za-z0-9]/, points: 1 }, // Has special char
    { regex: /.{12,}/, points: 1 }, // Length >= 12
  ];

  checks.forEach(({ regex, points }) => {
    if (regex.test(password)) {
      score += points;
    }
  });

  if (score <= 2) {
    return { score: (score / 6) * 100, label: 'Weak', variant: 'danger' };
  } else if (score <= 4) {
    return { score: (score / 6) * 100, label: 'Medium', variant: 'warning' };
  } else {
    return { score: (score / 6) * 100, label: 'Strong', variant: 'success' };
  }
};

